export var MIN_LOAN_AMOUNT = 3000;
export var LIBERIS_MAX_LOAN_AMOUNT = 1200000;
export var PRAGMA_MAX_LOAN_AMOUNT = 200000;
export var SPECIAL_OFFER_LOAN_AMOUNT = 5000;
export var SPECIAL_OFFER_LOAN_INTEREST = 2;
export var SPECIAL_OFFER_LOAN_PERIOD = 2;
export var CURRENCY = 'PLN';
